<div class="container pt-120">

	<div class="row pt-4">
		<div class="col col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 filter-side">
			<div class="pr-4 filter-container pb-5">
				<h4 class="mb-4">{{'FIND_EVENT' | translate}}</h4>
				<form [formGroup]="filterForm">
					<ng-container formGroupName="filter">

						<div class="form-group label-floating is-empty" [ngClass]="{'is-empty': !filterForm.get('filter').get('search_value').value}">
							<label class="control-label">{{'TITLE_DESCRIPTION' | translate}}</label>
							<input class="form-control" placeholder="" formControlName="search_value" type="text" (focus)="focusedField($event)" (blur)="focusedField($event)">
						</div>

						<div class="ngbDatepicker form-group label-floating"
							[ngClass]="{'is-empty': !filterForm.get('filter').get('startingDate').value}">
							<label class="control-label">{{'START_DATE' | translate}}</label>
							<input class="form-control" name="dp" placeholder="aaaa-mm-jj" ngbDatepicker (focus)="focusedField($event)" (blur)="focusedField($event)"
								[maxDate]="filterForm.get('filter').get('endDate').value ? filterForm.get('filter').get('endDate').value : maxDate" [minDate]="minDate"
								#dStart="ngbDatepicker" formControlName="startingDate">
							<button class="btn btn-outline-secondary icon-calendar mb-0" (click)="dStart.toggle()"
								type="button">
								<svg class="olymp-calendar-icon icon">
									<use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-calendar-icon"></use>
								</svg>
							</button>
						</div>

						<div class="ngbDatepicker form-group label-floating"
							[ngClass]="{'is-empty': !filterForm.get('filter').get('endDate').value}">
							<label class="control-label">{{'END_DATE' | translate}}</label>
							<input class="form-control" name="dp" placeholder="aaaa-mm-jj" ngbDatepicker (focus)="focusedField($event)" (blur)="focusedField($event)"
								[maxDate]="maxDate" [minDate]="filterForm.get('filter').get('startingDate').value ? filterForm.get('filter').get('startingDate').value : minDate"
								#dEnd="ngbDatepicker" formControlName="endDate">
							<button class="btn btn-outline-secondary icon-calendar mb-0" (click)="dEnd.toggle()"
								type="button">
								<svg class="olymp-calendar-icon icon">
									<use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-calendar-icon"></use>
								</svg>
							</button>
						</div>

						<button class="btn btn-primary btn-md-2 full-width px-1" (click)="search()">{{'BUTTON.APPLY' | translate}}</button>
						<button class="btn btn-secondary btn-md-2 full-width mb-0 px-1" (click)="cancel()">{{'BUTTON.RESET' | translate}}</button>
					</ng-container>
				</form>
			</div>
		</div>
		<div class="col col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
			<section class="blog-post-wrap">
				<div class="sorting mb-5">
					<form [formGroup]="filterForm">
						<ng-container formGroupName="sorting">
							<div class="form-group"
								[ngClass]="{'is-empty': !filterForm.get('sorting').get('order_by_sorting').value}">
								<label class="control-label mb-0">{{'ORDER' | translate}} :</label>
								<ng-select formControlName='order_by_sorting' (focus)="focusedField($event)"
									(blur)="focusedField($event)" (change)="filterEvent()">
									<ng-option value="DESC">Date <i class="fas fa-sort-amount-up"></i></ng-option>
									<ng-option value="ASC">Date <i class="fas fa-sort-amount-down-alt"></i></ng-option>
								</ng-select>
							</div>
						</ng-container>
					</form>
				</div>
				<div class="row">
					<ng-container *ngIf="loadingEvents">
						<div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" *ngFor="card of ['','','']">
							<app-card-skeleton [adminView]="false" ></app-card-skeleton>
						</div>
					</ng-container>
					<ng-container *ngIf="!loadingEvents">
						<div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" *ngFor="let event of events">
							<app-event-card-admin [adminView]="false" [event]="event"></app-event-card-admin>
						</div>
					</ng-container>

				</div>


				<!-- Pagination -->
				<ngb-pagination *ngIf="eventCount > paginationArgs.pageSize" class="pagination__count"
					[collectionSize]="eventCount" [page]="paginationArgs.pageNumber"
					[pageSize]="paginationArgs.pageSize" [maxSize]="5" [boundaryLinks]="false"
					(pageChange)="changePage($event)">
					<ng-template ngbPaginationPrevious><i class="fas fa-angle-left"></i></ng-template>
					<ng-template ngbPaginationNext><i class="fas fa-angle-right"></i></ng-template>
					<ng-template ngbPaginationEllipsis>...</ng-template>
					<ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
				</ngb-pagination>

				<!-- ... end Pagination -->

			</section>

		</div>
	</div>
</div>